<template>
  <div>
    <AppDialog
      class="time-off-policies-wizard"
      data-testid="time-off-policies-wizard"
      title="Add time off policy"
      :show="showDialog"
      append-to-body
      :position="dialogPosition"
      @close="closeDialogs"
    >
      <AppWizard
        :value="step"
        :steps="wizardSteps"
      >
        <ValidationObserver ref="dialogObserver">
          <AppWizardStep
            v-show="step === 0"
            :show-back-button="false"
            :show-delete-button="false"
            @previous="previousStep"
            @next="nextStep"
            @tab-selected="changeTab"
            @close="closeDialogs"
          >
            <ValidationObserver ref="TimeOffPolicySetupFormObserver">
              <component
                :is="monthlyAccrualEnabled ? 'TimeOffPolicySetupFormV2' : 'TimeOffPolicySetupForm'"
                v-if="showDialog"
                :time-off-policy="timeOffPolicy"
                :org-time-zone="orgTimeZone"
                :dropdown-options="dropdownOptions"
                :show-dialog="showDialog"
                :editing="editing"
              />
            </ValidationObserver>
          </AppWizardStep>
          <AppWizardStep
            v-show="step === 1"
            show-back-button
            is-last-step
            :save-button-text="saveButtonText"
            :save-button-disabled="saving"
            @previous="previousStep"
            @tab-selected="changeTab"
            @input="save"
            @close="closeDialogs"
          >
            <ValidationObserver ref="TimeOffPolicyMembersSetupFormObserver">
              <TimeOffPolicyMembersSetupForm
                v-if="showDialog"
                :time-off-policy="timeOffPolicy"
                :organization-id="organizationId"
                :members-data="membersData"
                :show-dialog="showDialog"
                :countries="countries"
                @policy-updated="policyUpdated"
                @member-options-updated="memberOptionsUpdated"
              />
            </ValidationObserver>
          </AppWizardStep>
        </ValidationObserver>
      </AppWizard>
    </AppDialog>
  </div>
</template>

<script>
import TimeOffPolicyMixin from '~/mixins/time_off_policies/TimeOffPolicyMixin';
import TimeOffPolicySetupForm from '~/components/time_off_policies/TimeOffPolicySetupForm.vue';
import TimeOffPolicySetupFormV2 from '~/components/time_off_policies/TimeOffPolicySetupFormV2.vue';
import TimeOffPolicyMembersSetupForm from '~/components/time_off_policies/TimeOffPolicyMembersSetupForm.vue';

export default {
  name: 'TimeOffPolicyWizard',
  components: {
    TimeOffPolicySetupForm,
    TimeOffPolicyMembersSetupForm,
    TimeOffPolicySetupFormV2,
  },
  mixins: [TimeOffPolicyMixin],
  data() {
    return {
      step: 0,
    };
  },
  computed: {
    wizardSteps() {
      return [{ title: 'Set up policy' }, { title: 'Assign members' }];
    },
    saveButtonText() {
      return this.saving ? 'Saving...' : 'Save';
    },
    dialogPosition() {
      return this.monthlyAccrualEnabled ? 'top' : 'centered';
    },
  },
  methods: {
    previousStep() {
      this.step--;
    },
    nextStep() {
      this.$refs.TimeOffPolicySetupFormObserver.validate().then((result) => {
        if (result) {
          this.step++;
        }
      });
    },
    changeTab(tabId) {
      const id = Number(tabId.replace('tab-', ''));

      this.step = id;
    },
  },
};
</script>
